import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { noop } from 'rxjs';
import {
  BASE_PERMISSIONS,
  BaseCoreState,
  baseInquiryActions,
  BaseInquiryStatus,
  BaseModalService,
  BaseRolesService,
  CustomerInquiryListItemResponse,
} from 'base';
import { BaseCustomerInquiryService } from '../../../inquiry/inquiry.service';
import { BaseCustomerUnpublishedInquiryActionsEnum } from '../../_enums/base-customer-unpublished-inquiry-actions.enum';

@Component({
  selector: 'base-customer-dashboard-unpublished-inquiries',
  templateUrl: './base-customer-dashboard-unpublished-inquiries.component.html',
})
export class BaseCustomerDashboardUnpublishedInquiriesComponent implements OnChanges, OnInit {
  @ViewChild('closeInquiryModal', { static: true }) closeInquiryModal: ElementRef;
  @Input() unpublishedInquiries: CustomerInquiryListItemResponse[];
  states: string[] = [];
  canPublishInquiry: boolean;
  onInquiryCloseModalRef: NgbModalRef;
  inquiryActionsEnum = BaseCustomerUnpublishedInquiryActionsEnum;

  constructor(
    private store: Store<BaseCoreState>,
    private modalService: BaseModalService,
    private rolesService: BaseRolesService,
    private baseCustomerInquiryService: BaseCustomerInquiryService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['unpublishedInquiries']) {
      this.unpublishedInquiries?.forEach((inquiry) => {
        this.states.push(this.getInquiryStatus(inquiry.status as number));
      });
    }
  }

  ngOnInit(): void {
    this.canPublishInquiry = this.rolesService.hasCustomerFeaturePermission(BASE_PERMISSIONS.FEATURE_PUBLISH_INQUIRY);
  }

  getInquiryStatus(i: number) {
    return 'states.' + Object.values(BaseInquiryStatus)[i - 1];
  }

  onPublish(inquiryId: number) {
    const modalRef = this.modalService.open(
      {
        headText: 'inquiry.publishInquiryNow',
        bodyText: 'inquiry.publishInquiryConfirmText',
        okText: 'action.yesPublish',
        cancelButtonBackground: 'secondary',
        cancelButtonDisplayed: true,
      },
      {
        scrollable: false,
        backdrop: true,
        size: 'md',
      }
    );

    modalRef.result.then(() => {
      this.store.dispatch(
        baseInquiryActions.updateInquiryStatus({
          payload: {
            inquiry: inquiryId,
            status: BaseInquiryStatus.published,
            loadUnpublishedInquiries: true,
          },
        })
      );
    }, noop);
  }

  handleClick(actionType: BaseCustomerUnpublishedInquiryActionsEnum, inquiryId: number) {
    switch (actionType) {
      case this.inquiryActionsEnum.edit:
        this.onEdit(inquiryId);
        break;
      case this.inquiryActionsEnum.release:
        this.onPublish(inquiryId);
        break;
      case this.inquiryActionsEnum.close:
        this.onClose(inquiryId);
        break;
    }
  }

  private onEdit(inquiryId: number) {
    this.baseCustomerInquiryService.getInquiry(inquiryId).subscribe((inquiry) => {
      this.baseCustomerInquiryService.openShiftViewPage(inquiry, inquiryId);
    });
  }

  private onClose(inquiryId: number): void {
    this.onInquiryCloseModalRef = this.modalService.open(
      {
        headText: 'inquiry.closeInquiry.headText',
        bodyTemplate: this.closeInquiryModal,
        hideFooter: true,
      },
      {
        backdrop: 'static',
        size: 'md',
      }
    );

    this.onInquiryCloseModalRef.result.then((value: string) => {
      this.updateCustomerInquiryStatus(inquiryId, BaseInquiryStatus.closed, value);
    }, noop);
  }

  private updateCustomerInquiryStatus(inquiry: number, status: 1 | 2 | 3, closedNote?: string): void {
    this.store.dispatch(
      baseInquiryActions.updateInquiryStatus({
        payload: { inquiry, status, closedNote, isDashboard: true },
      })
    );
  }

  trackByInquiry(_: number, item: CustomerInquiryListItemResponse) {
    return item.id;
  }
}
